import React, {FC} from 'react';
import styled from 'styled-components';

import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface CellRuleWrapperProps {
  isSelected?: boolean;
}

/*
 * Style.
 */

const StyledRuleDiv = styled.div`
  grid-area: bottom-left;
`;

const StyledContentDiv = styled.div`
  grid-area: bottom-line;
  display: flex;
  min-width: 0;
`;

/*
 * Component.
 */

export const CellRuleWrapper: FC<CellRuleWrapperProps> = (props) => {
  const theme = useUserTheme();

  return (
    <>
      <StyledRuleDiv>
        <Icon name="gearSmall" color={props.isSelected ? theme.alphas.white50 : theme.palette.blue.shade40} />
      </StyledRuleDiv>
      <StyledContentDiv>{props.children}</StyledContentDiv>
    </>
  );
};
